import { FormControl } from "@angular/forms";
import { Transform, Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { FormAnswer, FormAnswerObject } from "./form-answer.model";
import { FormTemplateCatgory } from "./form-template-category.model";
import { FormTemplateQuestion, QuestionTypeEnum } from "./form-template-question.model";
import { FormTemplateSection } from "./form-template-section.model";
import { QuestionText } from "./question-text.model";

export class FormTemplate extends BaseModel {
  id: number;
  uuid: string;
  name: string;
  internalName: string;
  description: string;
  minResponsesForAbrv: number;
  minResponsesForFull: number;
  formTemplateCategoryId: number;
  @Type(() => Boolean)
  hasSMC: boolean;
  @Type(() => Boolean)
  isCFET: boolean;
  @Type(() => Boolean)
  isAvailableOffline: boolean;
  @Type(() => Boolean)
  allowCobranding: boolean;
  @Type(() => Boolean)
  isDraft: boolean;
  @Type(() => Boolean)
  isArchived: boolean;
  timerInMinutes: number | null;
  alertBeforeEndTimerInMinutes: number | null;
  image: string | null;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  onlineThankyouMessage: string | null;
  @Type(() => FormTemplateSection)
  formTemplateSections: FormTemplateSection[];
  @Type(() => FormTemplateCatgory)
  formTemplateCategory: FormTemplateCatgory;

  public collectFormControls(
    answersToDefaultTo: FormAnswerObject = {},
  ): Record<string, FormControl> {
    return this.questions.reduce(
      (acc, curr) => ({
        ...acc,
        ...curr.collectFormControl(answersToDefaultTo),
      }),
      {},
    );
  }

  public collectCommentsFormControls(
    answersToDefaultTo: FormAnswerObject = {},
  ): Record<string, FormControl> {
    return this.collectAnsweredComments(answersToDefaultTo).reduce(
      (acc, curr) => {
        // new condtion to handle list question type for comments
        const control = curr.collectFormControl(answersToDefaultTo);
        const key = Object.keys(control)[0];
        const formControl = control[key];
        if (typeof formControl.value === 'object' && formControl.value !== null && !Array.isArray(formControl.value)) {          
          // If value is a JSON object, set it to null or handle as needed
          formControl.setValue(formControl.value.text);
        }
        else if (typeof formControl.value === 'object' && formControl.value !== null && Array.isArray(formControl.value)) {
          const firstWithText = formControl.value.find((item: any) => !!item.text && item.text.trim() !== '');
          formControl.setValue(firstWithText ? firstWithText.text : null);
        }
        return {
          ...acc,
          ...{ [key]: formControl },
        };
      },
      {},
    );
  }

  public get questions(): FormTemplateQuestion[] {
    return this.formTemplateSections.reduce(
      (sectionsAcc, sectionCurr) => [...sectionsAcc, ...sectionCurr.questions],
      [],
    );
  }

  public collectAnsweredComments(answers: FormAnswerObject = {}): QuestionText[] {
    const answeredComments = this.questions.filter((question) => {
      // new list question type added for comments 
      if (
        (question.type === QuestionTypeEnum.Text || question.type === QuestionTypeEnum.List) &&
        answers[question.id] !== undefined &&
        !Array.isArray(answers[question.id])
      ) {
        const textAnswer = answers[question.id] as FormAnswer;
        return !!textAnswer.editedStringData || !!textAnswer.stringData;
      }
      // new condtion to handle list type question with multipal selection for comments
      else if (
        (question.type === QuestionTypeEnum.List) &&
        answers[question.id] !== undefined &&
        Array.isArray(answers[question.id])
      ) {
        const textAnswers = answers[question.id] as FormAnswer[];
        return textAnswers.some(
          ans => !!ans.editedStringData || !!ans.stringData
        );
      }      
      return false;
    }) as QuestionText[];
    return answeredComments;
  }
}
